// extracted by mini-css-extract-plugin
export var showAboveTablet = "Header-module--showAboveTablet--hzcNN";
export var showBelowTablet = "Header-module--showBelowTablet--6Nb+n";